<mat-progress-bar
  *ngIf="isLoading === true"
  mode="indeterminate"
  color="accent"
></mat-progress-bar>
<div class="container">
  <h3>Failed Recommit Orders</h3>
  <div class="container" *ngIf="!dataExist">
    <label><span class="not-sent">* No Record to Display</span></label>
  </div>
  <mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="reProcess">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="selectAll($event)"></mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox
          [(ngModel)]="row.reProcess"
          (change)="changed($event)"
        ></mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
      <mat-cell *matCellDef="let order"> {{ order.email }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="createDate">
      <mat-header-cell *matHeaderCellDef> Create Date </mat-header-cell>
      <mat-cell *matCellDef="let order">
        {{ order.createDate | date: "shortDate" }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="accountName">
      <mat-header-cell *matHeaderCellDef> Account Name </mat-header-cell>
      <mat-cell *matCellDef="let order"> {{ order.accountName }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="salesOrderNumber">
      <mat-header-cell *matHeaderCellDef> Sales Order Number </mat-header-cell>
      <mat-cell *matCellDef="let order">
        {{ order.salesOrderNumber }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      tabindex="0"
    ></mat-row>
  </mat-table>
  <div class="container">
    <p>
      <button
        id="btnSubmit"
        [disabled]="!dataExist || recordsSaved"
        type="button"
        class="btn btn-bump-right"
        (click)="processData()"
      >
        Process
      </button>
    </p>
  </div>
</div>
<div class="container" *ngIf="recordsSaved">
  <label><span class="not-sent">Data Saved Successfully.</span></label>
</div>
